// Auto-generated - DO NOT EDIT
// This file is generated by scripts/generatePrivacyPolicyMetadata.js
// Last generated: 2026-11-04T08:15:56.643Z
// 
// The lastUpdated date is automatically updated when PrivacyPolicy.js content changes.
// The date reflects the month/year when the content was last modified.

export const lastUpdated = 'June 2026';
